// 1. Defer non-critical third-party scripts (improves FID/TBT)
(function () {
  const deferredScripts = [
    'https://www.googletagmanager.com/gtag/js',
    'https://connect.facebook.net',
    'https://www.google-analytics.com/analytics.js',
  ];

  function loadDeferredScripts() {
    deferredScripts.forEach(function (src) {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      document.body.appendChild(script);
    });
  }

  // Load after page is interactive
  if (document.readyState === 'complete') {
    setTimeout(loadDeferredScripts, 1000);
  } else {
    window.addEventListener('load', function () {
      setTimeout(loadDeferredScripts, 1000);
    });
  }
})();

// 2. Reduce Cumulative Layout Shift (CLS)
(function () {
  // Set explicit dimensions on images without them
  document.addEventListener('DOMContentLoaded', function () {
    const images = document.querySelectorAll('img:not([width]):not([height])');
    images.forEach(function (img) {
      if (img.naturalWidth && img.naturalHeight) {
        const aspectRatio = img.naturalHeight / img.naturalWidth;
        img.style.aspectRatio = '1 / ' + aspectRatio;
      }
    });
  });
})();

// 3. Improve First Input Delay (FID) by chunking long tasks
(function () {
  // Break up long JavaScript tasks
  if ('scheduler' in window && 'yield' in window.scheduler) {
    // Use modern scheduler API when available
    async function yieldToMain() {
      await scheduler.yield();
    }
    window.yieldToMain = yieldToMain;
  } else {
    // Fallback for older browsers
    function yieldToMain() {
      return new Promise(function (resolve) {
        setTimeout(resolve, 0);
      });
    }
    window.yieldToMain = yieldToMain;
  }
})();

// 5. Prefetch next likely navigation (improves perceived speed)
(function () {
  const prefetchQueue = [];
  let isPrefetching = false;

  function prefetchUrl(url) {
    if (prefetchQueue.includes(url)) return;

    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = url;
    link.as = 'document';
    document.head.appendChild(link);
    prefetchQueue.push(url);
  }

  // Prefetch on hover (mobile: on touch)
  document.addEventListener('mouseover', function (e) {
    const link = e.target.closest('a[href^="/"]');
    if (link && !isPrefetching) {
      isPrefetching = true;
      setTimeout(function () {
        prefetchUrl(link.href);
        isPrefetching = false;
      }, 100);
    }
  });
})();

// 6. Report Core Web Vitals to console (for debugging)
(function () {
  function logWebVital(_metric) {
    // Metrics tracked silently
  }

  if ('PerformanceObserver' in window) {
    // LCP
    new PerformanceObserver(function (list) {
      const entries = list.getEntries();
      const lastEntry = entries[entries.length - 1];
      logWebVital({
        name: 'LCP',
        value: lastEntry.renderTime || lastEntry.loadTime,
        rating:
          lastEntry.renderTime < 2500
            ? 'good'
            : lastEntry.renderTime < 4000
              ? 'needs-improvement'
              : 'poor',
      });
    }).observe({ type: 'largest-contentful-paint', buffered: true });

    // FID
    new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (entry) {
        logWebVital({
          name: 'FID',
          value: entry.processingStart - entry.startTime,
          rating:
            entry.processingStart - entry.startTime < 100
              ? 'good'
              : entry.processingStart - entry.startTime < 300
                ? 'needs-improvement'
                : 'poor',
        });
      });
    }).observe({ type: 'first-input', buffered: true });

    // CLS
    let clsValue = 0;
    new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (entry) {
        if (!entry.hadRecentInput) {
          clsValue += entry.value;
        }
      });
      logWebVital({
        name: 'CLS',
        value: clsValue,
        rating: clsValue < 0.1 ? 'good' : clsValue < 0.25 ? 'needs-improvement' : 'poor',
      });
    }).observe({ type: 'layout-shift', buffered: true });
  }
})();
